import { Youtube, Instagram, Play } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { BRAND, IMAGES } from "../../lib/site";

export default function Videos({ videos = [] }) {
  return (
    <section id="videos" className="py-20 lg:py-28" data-testid="videos-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="Music & Videos"
          title="Hear the Kroonerz"
          sub="The best way to know a singer is to hear them. Catch our performances on YouTube and Instagram."
        />
        {videos.length > 0 ? (
          <div className="mt-14 grid gap-6 md:grid-cols-2">
            {videos.map((v, i) => (
              <Reveal key={v.id || i} delay={0.08 * i}>
                <div className="overflow-hidden rounded-2xl border border-navy-700" data-testid={`video-embed-${i}`}>
                  <div className="aspect-video">
                    <iframe
                      src={`https://www.youtube-nocookie.com/embed/${v.id}`}
                      title={v.title || `Tricity Kroonerz performance ${i + 1}`}
                      loading="lazy"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="h-full w-full"
                    />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal delay={0.1}>
            <div className="relative mx-auto mt-14 max-w-3xl overflow-hidden rounded-2xl border border-gold/25" data-testid="videos-placeholder">
              <img src={IMAGES.hero} alt="Stage microphone in warm light" loading="lazy" className="h-72 w-full object-cover opacity-70 sm:h-96" />
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-navy-950/60 text-center">
                <a
                  href={BRAND.youtube}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="videos-play-button"
                  className="flex h-20 w-20 items-center justify-center rounded-full border border-gold/50 bg-navy-950/70 text-gold backdrop-blur transition-transform hover:scale-105"
                  aria-label="Watch Tricity Kroonerz on YouTube"
                >
                  <Play className="h-8 w-8 translate-x-0.5 fill-current" />
                </a>
                <p className="mt-5 font-serif text-xl italic text-ivory">Our latest performances live on YouTube</p>
              </div>
            </div>
          </Reveal>
        )}
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href={BRAND.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="videos-youtube-cta"
              className="inline-flex items-center gap-2 rounded-full bg-burgundy px-7 py-3.5 text-sm font-bold text-ivory transition-colors hover:bg-burgundy-light"
            >
              <Youtube className="h-5 w-5" /> Watch More on YouTube
            </a>
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="videos-instagram-cta"
              className="inline-flex items-center gap-2 rounded-full border border-navy-700 px-7 py-3.5 text-sm font-semibold text-ivory transition-colors hover:border-gold/50 hover:text-gold"
            >
              <Instagram className="h-5 w-5" /> Follow Us on Instagram
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
